import { makeApiActionCreatorV3 } from '@actions/utils';
import * as api from '../api/newYearLayer';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';

const prefix = 'PROCESS-MANAGER';

export const FETCH_NEW_YEAR_LAYER_RUNS = createRequestTypes(
  `${prefix}/FETCH_NEW_YEAR_LAYER_RUNS`,
);

export const fetchNewYearLayerRuns = makeApiActionCreatorV3(
  api.fetchNewYearLayerRuns,
  FETCH_NEW_YEAR_LAYER_RUNS[START],
  FETCH_NEW_YEAR_LAYER_RUNS[SUCCESS],
  FETCH_NEW_YEAR_LAYER_RUNS[ERROR],
);

export const CREATE_NEW_YEAR_LAYER = createRequestTypes(
  `${prefix}/UNDO_NEW_YEAR_LAYER`,
);

export const createNewYearLayer = makeApiActionCreatorV3(
  api.createNewYearLayer,
  CREATE_NEW_YEAR_LAYER[START],
  CREATE_NEW_YEAR_LAYER[SUCCESS],
  CREATE_NEW_YEAR_LAYER[ERROR],
);

export const UNDO_NEW_YEAR_LAYER = createRequestTypes(
  `${prefix}/UNDO_NEW_YEAR_LAYER`,
);

export const undoNewYearLayer = makeApiActionCreatorV3(
  api.undoNewYearLayer,
  UNDO_NEW_YEAR_LAYER[START],
  UNDO_NEW_YEAR_LAYER[SUCCESS],
  UNDO_NEW_YEAR_LAYER[ERROR],
);
